import { useEffect, useState } from "react";

type Options = {
  offset: string;
};

export function useScrollspy(sectionIds: string[], options: Options) {
  const [activeId, setActiveId] = useState<string | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        let selectedSectionId: string | null = null;

        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.setAttribute("data-scrollspy", "intersecting");

            selectedSectionId = entry.target.id;
          } else {
            entry.target.setAttribute("data-scrollspy", "idle");
          }
        }

        if (selectedSectionId) {
          setActiveId(selectedSectionId);
        }
      },
      {
        rootMargin: options.offset,
        threshold: 0,
      },
    );

    sectionIds.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return function dispose() {
      observer.disconnect();
    };
  }, [sectionIds, options.offset]);

  return { activeId };
}
